/**
 * Issue #342 — 课程分段批次配置 API 客户端（ADMIN+ / orgId 隔离 / 合法性校验 + 审计）。
 *   GET /admin/courses/:courseId/segments   批次配置 + 当前题量 + 校验提示
 *   PUT /admin/courses/:courseId/segments   覆盖式保存批次
 *
 * 类型契约的唯一来源(SSOT)是 apps/api/openapi.yaml，经 `pnpm codegen` 生成到
 * ./generated/types.ts；本模块只做派生，禁止手写字段定义。
 */
import { apiClient } from './api';
import type { components } from './generated/types';

export type AdminSegmentView = components['schemas']['SegmentView'];
export type SegmentIssue = components['schemas']['SegmentIssue'];
export type CourseSegmentsResult = components['schemas']['CourseSegmentsView'];
export type SegmentInput = components['schemas']['CourseSegmentInput'];

export function getCourseSegmentsApi(courseId: string): Promise<CourseSegmentsResult> {
  return apiClient.get<CourseSegmentsResult>(
    `/admin/courses/${encodeURIComponent(courseId)}/segments`,
  );
}

export function replaceCourseSegmentsApi(
  courseId: string,
  segments: SegmentInput[],
): Promise<CourseSegmentsResult> {
  return apiClient.put<CourseSegmentsResult>(
    `/admin/courses/${encodeURIComponent(courseId)}/segments`,
    { segments },
  );
}
